var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCarouselRightChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 29.752
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.117 29.752a1.117 1.117 0 01-.789-1.907L13.3 14.869.327 1.893A1.117 1.117 0 011.906.314L15.673 14.08a1.117 1.117 0 010 1.579L1.906 29.426a1.116 1.116 0 01-.79.327z",
    fill: "#fff"
  })));
}

export default SvgCarouselRightChevron;